import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { Icon } from '@common/components';

export function ExtensionReviewChanges({
  beforeTitle,
  beforeComponent,
  forwardComponent,
  afterTitle,
  afterComponent,
}) {
  return (
    <Row className="changes">
      <Col className="before" span={8}>
        {beforeTitle}
        <br />
        <strong>{beforeComponent}</strong>
      </Col>
      <Col className="delta" span={8}>
        <Icon icon="longArrowRight" kind="light" />
        {forwardComponent}
      </Col>
      <Col className="after" span={8}>
        {afterTitle}
        <br />
        <strong>{afterComponent}</strong>
      </Col>
    </Row>
  );
}

ExtensionReviewChanges.propTypes = {
  beforeTitle: PropTypes.string.isRequired,
  beforeComponent: PropTypes.node.isRequired,
  forwardComponent: PropTypes.node.isRequired,
  afterTitle: PropTypes.string.isRequired,
  afterComponent: PropTypes.node.isRequired,
};
